<template>
	<div class="accordion-item border-bottom-1 py-1 cursor-pointer" :class="{ 'expanded' : uicontrol.expanded }" @click="uicontrol.expanded = !uicontrol.expanded">
		<span class="accordion-header font-semibold py-2">{{item.title}}</span>
		<div class="accordion-element-content mb-3">{{item.content}}</div>
	</div>
</template>

<script>
export default {
	name: "AccordeonElement",
	props : ['item'],
	data() {
		return {
			uicontrol: {
				expanded: false
			}
		}
	},
}
</script>

<style scoped>

.accordion-header	{
	display: block;
}

.accordion-item {
	position: relative;
}

.accordion-element-content {
	display: none;
}

.accordion-item.expanded .accordion-element-content {
	display: block;
}

.accordion-item:last-child{
	border-bottom: none;
}

</style>